class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) {
      return;
    }

    this.notification.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) {
      return;
    }

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    document.dispatchEvent(
      new CustomEvent('urbexnow:cart-notification-open')
    );
  }

  close() {
    if (!this.notification) {
      return;
    }

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);

    document.dispatchEvent(
      new CustomEvent('urbexnow:cart-notification-close')
    );
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];

      if (!target || !sectionHTML) {
        return;
      }

      const replacement = this.getSectionInnerHTML(
        sectionHTML,
        section.selector
      );

      if (replacement !== null) {
        target.innerHTML = replacement;
      }
    });

    this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentHTML = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = documentHTML.querySelector(selector);

    return selectedElement ? selectedElement.innerHTML : null;
  }

  handleBodyClick(event) {
    const target = event.target;

    if (
      target === this.notification ||
      target.closest('cart-notification')
    ) {
      return;
    }

    const disclosure = target.closest('details-disclosure, header-menu');
    this.activeElement = disclosure
      ? disclosure.querySelector('summary')
      : null;

    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
